import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';

export default {
  install(Vue) {
    // html页面生成PDF文档
    Vue.prototype.getPdf = function (viewId, name, callback) {
      const canvasId = viewId ? document.getElementById(viewId) : document.body; // 实现自定义可传定义dom 不传默认为body
      html2Canvas(canvasId, {
        allowTaint: true,
      }).then((canvas) => {
        // const canvas1 = addWatermark(canvas,  require('../../../assets/img/common/bk-epk.png'));
        const pdf = new JsPDF('p', 'mm', 'a4'); // A4纸，纵向
        const ctx = canvas.getContext('2d');
        const a4w = 190;
        const a4h = 280; // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
        const imgHeight = Math.floor((a4h * canvas.width) / a4w); // 按A4显示比例换算一页图像的像素高度
        let renderedHeight = 0;

        while (renderedHeight < canvas.height) {
          const page = document.createElement('canvas');
          page.width = canvas.width;
          page.height = Math.min(imgHeight, canvas.height - renderedHeight); // 可能内容不足一页

          // let pageData = canvas1.toDataURL('image/jpeg', 1.0)
          // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page
            .getContext('2d')
            .putImageData(
              ctx.getImageData(
                0,
                renderedHeight,
                canvas.width,
                Math.min(imgHeight, canvas.height - renderedHeight)
              ),
              0,
              0
            );
          pdf.addImage(
            page.toDataURL('image/jpeg', 1.0),
            'JPEG',
            10,
            10,
            a4w,
            Math.min(a4h, (a4w * page.height) / page.width)
          ); // 添加图像到页面，保留10mm边距

          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) pdf.addPage(); // 如果后面还有内容，添加一个空页
        }

        // let contentWidth = canvas.width;
        // let contentHeight = canvas.height;
        // let pageHeight = contentWidth / 592.28 * 841.89;
        // let leftHeight = contentHeight
        // let position = 0
        // let imgWidth = 595.28
        // let imgHeight = 604 / contentWidth * contentHeight
        //
        // let pageData = canvas1.toDataURL('image/jpeg', 1.0)
        // let PDF = new JsPDF('', 'pt', 'a4')
        // if (leftHeight < pageHeight) {
        //     PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        // } else {
        //     while (leftHeight > 0) {
        //         PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
        //         leftHeight -= pageHeight
        //         position -= 841.89
        //         if (leftHeight > 0) {
        //             PDF.addPage()
        //         }
        //     }
        // }
        const timer = new Date().getTime(); // 文件名
        pdf.save(name || `${timer}.pdf`);
        try {
          callback && callback();
        } catch (e) {
          console.log(e);
        }
      });
    };

    // 获取html图片转格式化
    function DataURLToBlob(dataUrl) {
      const arr = dataUrl.split(',');
      const mime = arr[0].match(/(:(.*?);)/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }

    // 下载html生成图片
    Vue.prototype.downloadImg = function (viewId, name) {
      // let canvasId = document.body; //导出body下面的所有内容 可以根据实际情况替换
      // let canvasId = document.getElementById("pdfDom"); //例子
      const canvasId = viewId ? document.getElementById(viewId) : document.body; // 实现自定义可传定义dom 不传默认为body
      const a = document.createElement('a');
      html2Canvas(canvasId).then((canvas) => {
        const dom = document.body.appendChild(canvas);
        dom.style.display = 'none';
        a.style.display = 'none';
        document.body.removeChild(dom);
        const blob = DataURLToBlob(dom.toDataURL('iamge/png'));
        a.setAttribute('href', URL.createObjectURL(blob));
        a.setAttribute('download', `${name}.png`);
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      });
    };

    // 获取打印图片
    Vue.prototype.printImg = function (viewId, name) {
      // $(window).scrollTop(0); // jQuery 的方法
      document.body.scrollTop = 0; // IE的
      document.documentElement.scrollTop = 0; // 其他
      this.downloadImg(viewId, name);
    };

    /**
     * canvas添加水印
     * @param {canvas对象} canvas
     * @param {水印文字} text
     */
    // function addWatermark(canvas, str) {
    //     const ctx = canvas.getContext("2d");
    //     let imgScale = 1
    //     //创建新的图片对象
    //     let img = new Image();
    //     //指定图片的URL
    //     img.src = str;
    //     //浏览器加载图片完毕后再绘制图片
    //     img.onload = function () {
    //         //cxt.drawImage(img,0,0);
    //         ctx.rotate(-20 * Math.PI / 180)
    //         ctx.clearRect(0, 0, canvas.width, canvas.height);
    //
    //         let forIndex = canvas.width / 100 | 0
    //         for(let i = -10; i < 10; i++) {
    //             for(let j = -10; j < forIndex; j++) {
    //                 ctx.drawImage(img, //规定要使用的图像、画布或视频。
    //                     0, 0, //开始剪切的 x 坐标位置。
    //                     img.width, img.height,  //被剪切图像的高度。
    //                     0, 10,//在画布上放置图像的 x 、y坐标位置。
    //                     img.width * imgScale, img.height * imgScale  //要使用的图像的宽度、高度
    //                 )
    //             }
    //         }
    //     }
    //     return canvas;
    //
    // }
  },
};
